// import { Button, Modal, ModalBody, ModalFooter } from "@windmill/react-ui";
// import React, { useContext } from "react";
// import { FiTrash2 } from "react-icons/fi";
// import { useLocation } from "react-router-dom";

// //internal import
// import spinnerLoadingImage from "assets/img/spinner.gif";
// import { SidebarContext } from "context/SidebarContext";
// import AdminServices from "services/AdminServices";
// import StateServices from "services/StateServices";
// import CityServices from "services/CityServices";
// import MenuServices from "services/MenuServices";
// import { useState } from "react";
// import useToggleDrawer from "hooks/useToggleDrawer"
// import { notifyError, notifySuccess } from "utils/toast";
// import NotificationServices from "services/NotificationServices";
// import RoleServices from "services/RoleServices";

// const DeleteModal = ({ id,setIsCheck, title, useParamId, body }) => {
//   const { isModalOpen, closeModal, setIsUpdate } = useContext(SidebarContext);
//   const { setServiceId} = useToggleDrawer();
//   const location = useLocation();

//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const handleDelete = async () => {
//     // return notifyError("CRUD operation is disabled for this option!");
//     try {
//       setIsSubmitting(true);


//       if (location.pathname === "/users") {
//         const res = await AdminServices.deleteStaff(id);
//         setIsUpdate(true);
//         notifySuccess(res.message);
//         setServiceId("");
//         closeModal();
//         setIsSubmitting(false);
//       }
//       if (location.pathname === "/states") {
//         const res = await StateServices.deleteState(id);
//         setIsUpdate(true);
//         notifySuccess(res.message);
//         setServiceId("");
//         closeModal();
//         setIsSubmitting(false);
//       }
//       if (location.pathname === "/city") {
//         const res = await CityServices.deleteCity(id);
//         setIsUpdate(true);
//         notifySuccess(res.message);
//         setServiceId("");
//         closeModal();
//         setIsSubmitting(false);
//       }
     
//       if (location.pathname === "/roles") {
//         const res = await RoleServices.deleteRole(id);
//         setIsUpdate(true);
//         notifySuccess(res.message);
//         setServiceId("");
//         closeModal();
//         setIsSubmitting(false);
//       }
      
//       if (location.pathname === "/menu") {
//         const res = await MenuServices.deleteMenu(id);
//         setIsUpdate(true);
//         notifySuccess(res.message);
//         setServiceId("");
//         closeModal();
//         setIsSubmitting(false);
//       }
      
      
//       if (location.pathname === "/notification") {
//         const res = await NotificationServices.deleteNotification(id,body);
//         setIsUpdate(true);
//         notifySuccess(res.message);
//         setServiceId("");
//         closeModal();
//         setIsSubmitting(false);
//       }

//     } catch (err) {
//       notifyError(err ? err?.response?.data?.message : err?.message);
//       setServiceId("");
//       setIsCheck([]);
//       closeModal();
//       setIsSubmitting(false);
//     }
//     finally{
//       setIsSubmitting(false);
//     }
//   };

//   return (
//     <>
//       <Modal isOpen={isModalOpen} onClose={closeModal}>
//         <ModalBody className="text-center custom-modal px-8 pt-6 pb-4">
//           <span className="flex justify-center text-3xl mb-6 text-red-500">
//             <FiTrash2 />
//           </span>
//           <h2 className="text-xl font-medium mb-2">
//           Are You Sure! Want to Delete{" "}<span className="text-red-500">{title}</span>?
//           </h2>
//           <p>Do you really want to delete these records? You can't view this in your list anymore if you delete!</p>
//         </ModalBody>

//         <ModalFooter className="justify-center">
//           <Button
//             className="w-full sm:w-auto hover:bg-white hover:border-gray-50"
//             layout="outline"
//             onClick={closeModal}
//           >
//             No, Keep It
//           </Button>
//           <div className="flex justify-end">
//             {isSubmitting ? (
//               <Button
//                 disabled={true}
//                 type="button"
//                 className="w-full h-12 sm:w-auto"
//               >
//                 <img
//                   src={spinnerLoadingImage}
//                   alt="Loading"
//                   width={20}
//                   height={10}
//                 />{" "}
//                 <span className="font-serif ml-2 font-light">
//                   Processing
//                 </span>
//               </Button>
//             ) : (
//               <Button onClick={handleDelete} className="w-full h-12 sm:w-auto">
//                  Yes, Delete It
//               </Button>
           
//             )}
//           </div>
//         </ModalFooter>
//       </Modal>
//     </>
//   );
// };

// export default React.memo(DeleteModal);




import { Button, Modal, ModalBody, ModalFooter } from "@windmill/react-ui";
import React, { useContext, useState } from "react";
import { FiTrash2 } from "react-icons/fi";
import { useLocation } from "react-router-dom";

import spinnerLoadingImage from "assets/img/spinner.gif";
import { SidebarContext } from "context/SidebarContext";
import AdminServices from "services/AdminServices";
import StateServices from "services/StateServices";
import CityServices from "services/CityServices";
import MenuServices from "services/MenuServices";
import useToggleDrawer from "hooks/useToggleDrawer";
import { notifyError, notifySuccess } from "utils/toast";
import NotificationServices from "services/NotificationServices";
import RoleServices from "services/RoleServices";

const DeleteModal = ({ id, setIsCheck, title, useParamId, body }) => {
  const { isModalOpen, closeModal, setIsUpdate } =
    useContext(SidebarContext);

  const { setServiceId } = useToggleDrawer();
  const location = useLocation();

  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleDelete = async () => {
    if (isSubmitting) return;

    setIsSubmitting(true);

    try {
      let res;

      switch (location.pathname) {
        case "/users":
          res = await AdminServices.deleteStaff(id);
          break;

        case "/states":
          res = await StateServices.deleteState(id);
          break;

        case "/city":
          res = await CityServices.deleteCity(id);
          break;

        case "/roles":
          res = await RoleServices.deleteRole(id);
          break;

        case "/menu":
          res = await MenuServices.deleteMenu(id);
          break;

        case "/notification":
          res = await NotificationServices.deleteNotification(id, body);
          break;

        default:
          throw new Error("Delete operation is not available for this page.");
      }

      setIsUpdate(true);
      notifySuccess(res.message);
      setServiceId("");
      closeModal();
    } catch (err) {
      notifyError(
        err?.response?.data?.message ||
          err?.message ||
          "Failed to delete the record."
      );

      setServiceId("");
      setIsCheck?.([]);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleClose = () => {
    if (isSubmitting) return;
    closeModal();
  };

  return (
    <Modal isOpen={isModalOpen} onClose={handleClose}>
      <ModalBody className="text-center custom-modal px-8 pt-6 pb-4">
        <span className="flex justify-center text-3xl mb-6 text-red-500">
          <FiTrash2 />
        </span>

        <h2 className="text-xl font-medium mb-2">
          Are You Sure! Want to Delete{" "}
          <span className="text-red-500">{title}</span>?
        </h2>

        <p>
          Do you really want to delete these records? You can't view this in
          your list anymore if you delete!
        </p>
      </ModalBody>

      <ModalFooter className="justify-center">
        <Button
          className="w-full sm:w-auto hover:bg-white hover:border-gray-50"
          layout="outline"
          onClick={handleClose}
          disabled={isSubmitting}
        >
          No, Keep It
        </Button>

        <div className="flex justify-end">
          <Button
            onClick={handleDelete}
            disabled={isSubmitting}
            type="button"
            className="w-full h-12 sm:w-auto"
          >
            {isSubmitting ? (
              <>
                <img
                  src={spinnerLoadingImage}
                  alt="Loading"
                  width={20}
                  height={10}
                />{" "}
                <span className="font-serif ml-2 font-light">
                  Processing
                </span>
              </>
            ) : (
              "Yes, Delete It"
            )}
          </Button>
        </div>
      </ModalFooter>
    </Modal>
  );
};

export default React.memo(DeleteModal);
